import type { SignInResult } from "@buildpy/core/modules/org/action-types";

// 가입 확인 안내는 틀린 이메일·비밀번호(없는 계정 포함 invalid)일 때만 — 장애·조직 없음·빈 칸엔 띄우지 않는다.
export const signupHintOf = (result: SignInResult): boolean => !result.ok && result.reason === "invalid";
